<template>
  <div>
    <b-btn-group v-if="filterOptions" v-for="(filter, filterIndex) in filters" :key="filterIndex" class="mr-2 mb-2">
      <!-- <b-button variant='light'>Date Range:</b-button> -->
      <b-button v-if="canDeleteFilter(filter)" variant="outline-dark" @click="removeFilter(filterIndex)"><icon name="delete" size="11"></icon></b-button>
      <span class="btn btn-outline-dark disabled">{{filterNames[filterIndex]}}</span>
      <date-filter :filter="filter" v-if="filter.type === 'logged_at' || filter.type === 'closed_at'" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></date-filter>
      <team-filter :filter="filter" v-if="filter.type === 'originator_team' || filter.type === 'creator_team'" :companies="filterOptions.companies" :allTeams="filterOptions.teams" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></team-filter>
      <issue-type-filter :filter="filter" v-if="filter.type === 'issue_type'" :eventTypes="filterOptions.event_types" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></issue-type-filter>
      <list-filter :filter="filter" v-if="filter.type === 'root_cause'" itemTypeName="Root Cause" :allItems="filterOptions.root_causes" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></list-filter>
      <list-filter :filter="filter" v-if="filter.type === 'event_type'" itemTypeName="Event Type" :allItems="filterOptions.event_types" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></list-filter>
      <list-filter :filter="filter" v-if="filter.type === 'company'" itemTypeName="Company" :allItems="filterOptions.companies" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)" infoText="The company filter is only available for administrators. When a normal user runs a report an implicit company filter is applied matching their company."></list-filter>
      <data-entry-filter :filter="filter" v-if="filter.type === 'data_entry'" :dataEntryFields="filterOptions.data_entry_fields" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></data-entry-filter>
      <job-number-filter :filter="filter" v-if="filter.type === 'job_number'" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></job-number-filter>
      <event-status-filter :filter="filter" v-if="filter.type === 'event_status'" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></event-status-filter>
      <column-filter :filter="filter" v-if="filter.type === 'column'" :report="report" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></column-filter>
      <user-filter :filter="filter" v-if="filter.type === 'creator_user'" :users="filterOptions.users" v-on:input="filtersUpdated" :disabled="!canEditFilter(filter)"></user-filter>
    </b-btn-group>
    <b-btn-group class="mr-2 mb-2">
      <b-dropdown variant="secondary" text="Add Filter" v-if="filterOptions">
        <b-dropdown-item-button v-for="(filter, filterIndex) in availableFilterTypes" :key="filterIndex" @click="addFilter(filter)">{{filter.name}}</b-dropdown-item-button>
      </b-dropdown>
    </b-btn-group>
  </div>
</template>

<script>
import _ from 'lodash'
import Icon from '@/components/Icon'
import DateFilter from '@/components/reports/DateFilter'
import TeamFilter from '@/components/reports/TeamFilter'
import ListFilter from '@/components/reports/ListFilter'
import IssueTypeFilter from '@/components/reports/IssueTypeFilter'
import DataEntryFilter from '@/components/reports/DataEntryFilter'
import JobNumberFilter from '@/components/reports/JobNumberFilter'
import EventStatusFilter from '@/components/reports/EventStatusFilter'
import ColumnFilter from '@/components/reports/ColumnFilter'
import UserFilter from '@/components/reports/UserFilter'

export default {
  name: 'FiltersEditor',
  props: ['value', 'report', 'filterOptions', 'admin'],
  components: {
    Icon, DateFilter, TeamFilter, ListFilter, IssueTypeFilter, DataEntryFilter, JobNumberFilter, EventStatusFilter, ColumnFilter, UserFilter
  },
  data () {
    var filters = _.cloneDeep(this.value)
    if (filters == null) {
      filters = []
    }
    return {
      filters: filters,
      filterNames: filters.map((filter) => { return this.filterName(filter) })
    }
  },
  computed: {
    availableFilterTypes () {
      return this.filterOptions.filters.filter((f) => {
        if (f.type === 'data_entry') {
          return true
        }
        return this.filters.find((activeFilter) => {
          return activeFilter.type === f.type
        }) == null
      })
    }
  },
  watch: {
    'value' () {
      var filters = this.value
      if (filters == null) {
        filters = []
      }
      this.filters = filters
      this.filterNames = this.filters.map((filter) => { return this.filterName(filter) })
    }
  },
  mounted () {
  },
  methods: {
    addFilter (template) {
      var filter = { type: template.type }
      switch (template.type) {
        case 'logged_at':
        case 'closed_at':
          _.merge(filter, { range_type: 'recent', count: 2, period_type: 'weeks' })
          break
        case 'originator_team':
        case 'creator_team':
          if (this.filterOptions.companies != null) {
            _.merge(filter, { company_id: null, team_ids: [] })
          } else {
            _.merge(filter, { team_ids: this.filterOptions.teams.map((t) => { return t.id }) })
          }
          break
        case 'issue_type':
          _.merge(filter, { ids: [this.filterOptions.event_types.filter((et) => { return et.issue_types.length > 0 })[0].issue_types[0].id] })
          break
        case 'root_cause':
          _.merge(filter, { ids: [this.filterOptions.root_causes[0].id] })
          break
        case 'event_type':
          _.merge(filter, { ids: [this.filterOptions.event_types[0].id] })
          break
        case 'event_status':
          _.merge(filter, { status: 'open' })
          break
        case 'company':
          _.merge(filter, { ids: [this.filterOptions.companies[0].id] })
          break
        case 'creator_user':
          _.merge(filter, { ids: [this.filterOptions.users[0].id] })
          break
      }
      this.filters.push(filter)
      this.filtersUpdated()
    },
    removeFilter (index) {
      this.filters.splice(index, 1)
      this.filtersUpdated()
    },
    filterName (filter) {
      if (filter.type === 'data_entry') {
        if (filter.field_id != null) {
          const field = this.filterOptions.data_entry_fields.find((field) => { return field.id === parseInt(filter.field_id) })
          if (field != null) {
            return field.short_name
          }
        }
      } else if (filter.type === 'column') {
        return filter.column.label
      }
      return this.filterOptions.filters.find((template) => { return template.type === filter.type }).name
    },
    canEditFilter (filter) {
      return filter.lock == null || filter.lock === 'open'
    },
    canDeleteFilter (filter) {
      return filter.lock == null || filter.lock === 'open' || filter.lock === 'noedit'
    },
    filtersUpdated () {
      this.filterNames = this.filters.map((filter) => { return this.filterName(filter) })
      this.emitChange()
    },
    emitChange () {
      this.$emit('input', this.filters)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/reports/FiltersEditor.vue